export default "__VITE_ASSET__33023be6__"